import React from 'react';
export function BonusSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white py-10 px-4 md:px-8" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-2" data-id="element-21">
            🎁 BONOS GRATIS HOY
          </h2>
          <p className="text-xl text-gray-600" data-id="element-22">Te llevás 2 bonos exclusivos:</p>
        </div>

        <div className="space-y-8" data-id="element-23">
          {/* Bonus 1 */}
          <div className="flex flex-col md:flex-row items-center gap-6 bg-gray-50 p-5 rounded-2xl border border-gray-200" data-id="element-24">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/xcbTCy6qLgfX3NWgB4g4o1/PLANIFICACION_ANUAL_PRIMARIA_.png" alt="Planificación Anual Lista" className="w-[250px] h-[250px] object-contain cursor-pointer hover:scale-105 transition-transform" onClick={scrollToPricing} data-id="element-26" />
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-27">
              <span className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm mb-3" data-id="element-28">
                🎁 BONO 1 – GRATIS
              </span>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-29">
                📅 Planificación Anual Lista
              </h3>
              <p className="text-lg text-gray-700" data-id="element-30">
                Organizá todo el ciclo escolar con una estructura clara y lista
                para usar.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col md:flex-row items-center gap-6 bg-gray-50 p-5 rounded-2xl border border-gray-200" data-id="element-31">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/ikXmxs4NJY2GaE5Gzzn9N3/ACTIVIDADES_EXTRA_POR_GRADO_PRIMARIA.png" alt="Actividades Extra por Grado" className="w-[250px] h-[250px] object-contain cursor-pointer hover:scale-105 transition-transform" onClick={scrollToPricing} data-id="element-33" />
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-34">
              <span className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm mb-3" data-id="element-35">
                🎁 BONO 2 – GRATIS
              </span>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-36">
                📚 Actividades Extra por Grado
              </h3>
              <p className="text-lg text-gray-700" data-id="element-37">
                Más recursos prácticos para reforzar contenidos sin perder
                tiempo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}